import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { UATConstants } from 'src/Common/Models/UATConstants';
import { MANAGE_VIEW_API_CONSTANTS } from '../../utils/ManageViewConstants';

export const dropdownDataApi = createApi({
  reducerPath: 'dropdownDataApi',
  baseQuery: fetchBaseQuery({
    baseUrl: UATConstants.WebApiUrl,
    prepareHeaders: (headers) => {
      const token = sessionStorage.getItem(UATConstants.jwtTokenForApi);
      const coreAPIToken = sessionStorage.getItem(UATConstants.jwtTokenForCoreApi);
      const graphToken = sessionStorage.getItem(UATConstants.jwtTokenForGraph);

      if (token && graphToken && coreAPIToken) {
        headers.set('Authorization', `Bearer ${token}`);
        headers.set('Coreapitoken', coreAPIToken);
        headers.set('Graphtoken', graphToken);
      }
      return headers;
    },
  }),
  tagTypes: ['getDropdownData', 'GetToolsName'],
  endpoints: (builder) => ({
    getDropdownData: builder.query<unknown[], string>({
      query: () => ({
        method: 'GET',
        url: MANAGE_VIEW_API_CONSTANTS.GetDropdownData,
      }),
      providesTags: ['getDropdownData'],
    }),
    GetToolsName: builder.query<any[], string>({
      query: () => ({
        method: 'GET',
        url: MANAGE_VIEW_API_CONSTANTS.GetToolsName,
      }),
      providesTags: ['GetToolsName'],
    }),
  }),
});

export const { useGetDropdownDataQuery, useGetToolsNameQuery } = dropdownDataApi;
